var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",attrs:{"id":"btn-scrolltotop"},on:{"click":function($event){return _vm.scrollToTop()}}},[_c('span',{staticClass:"icon-flecha-arriba"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }